var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "current_password",
    label: "現在のパスワード",
    type: types.PASSWORD,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "A"
    },
  },
  {
    id: "new_password",
    label: "新しいパスワード",
    type: types.PASSWORD,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "B"
    },
  },
  {
    id: "confirm_password",
    label: "新しいパスワード(確認)",
    type: types.PASSWORD,
    import: { enabled: true },
    export: { 
      enabled: true,
      sequence: 1000,
      master_system: "C"
    },
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_master_change_password.js